import { useCallback } from 'react';

import { FormattedMessage } from 'react-intl';

import { dismissStatus } from 'mastodon/actions/statuses';
import { useAppDispatch } from 'mastodon/store';

import type { BaseConfirmationModalProps } from './confirmation_modal';

interface Props extends BaseConfirmationModalProps {
  statusId: string;
  acct: string;
}

export const ConfirmDismissStatusModal: React.FC<Props> = ({
  statusId,
  acct,
  onClose,
}) => {
  const dispatch = useAppDispatch();

  const handleNotInterested = useCallback(() => {
    dispatch(dismissStatus(statusId, 'not_interested'));
    onClose();
  }, [dispatch, statusId, onClose]);

  const handleLessFromUser = useCallback(() => {
    dispatch(dismissStatus(statusId, 'less_from_user'));
    onClose();
  }, [dispatch, statusId, onClose]);

  return (
    <div className='modal-root__modal safety-action-modal dismiss-status-modal'>
      <div className='safety-action-modal__top'>
        <div className='safety-action-modal__confirmation'>
          <h1>
            <FormattedMessage
              id='confirmations.dismiss_status.title'
              defaultMessage='Why are you not interested?'
            />
          </h1>
          <p>
            <FormattedMessage
              id='confirmations.dismiss_status.message'
              defaultMessage="You'll see less of this in your feed."
            />
          </p>

          <div className='dismiss-status-modal__options'>
            <button
              type='button'
              className='dismiss-status-modal__option'
              onClick={handleNotInterested}
            >
              <FormattedMessage
                id='confirmations.dismiss_status.not_interested'
                defaultMessage="I didn't like this post"
              />
            </button>
            <button
              type='button'
              className='dismiss-status-modal__option'
              onClick={handleLessFromUser}
            >
              <FormattedMessage
                id='confirmations.dismiss_status.less_from_user'
                defaultMessage='Show me less from @{acct}'
                values={{ acct }}
              />
            </button>
          </div>
        </div>
      </div>

      <div className='safety-action-modal__bottom'>
        <div className='safety-action-modal__actions'>
          <button onClick={onClose} className='link-button'>
            <FormattedMessage
              id='confirmation_modal.cancel'
              defaultMessage='Cancel'
            />
          </button>
        </div>
      </div>
    </div>
  );
};
